<template>
  <div
    v-if="open && ticket"
    class="dlg-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ticket-edit-title"
    @keydown.esc="emitClose"
  >
    <div class="dlg">
      <div class="dlg-header">
        <h2 id="ticket-edit-title">
          Ticket bearbeiten
        </h2>
        <button
          class="icon-btn"
          aria-label="Schließen"
          @click="emitClose"
        >
          ✕
        </button>
      </div>

      <div class="form">
        <div class="field">
          <label>Betreff</label>
          <input
            :value="ticket.subject"
            readonly
          >
          <p class="help">
            Der Betreff ist derzeit schreibgeschützt.
          </p>
        </div>

        <div class="field">
          <label for="te-status">Status</label>
          <select
            id="te-status"
            v-model="status"
          >
            <option value="open">
              Offen
            </option>
            <option value="in_progress">
              In Bearbeitung
            </option>
            <option value="resolved">
              Gelöst
            </option>
            <option value="closed">
              Geschlossen
            </option>
          </select>
        </div>

        <p
          v-if="error"
          class="notice notice-danger mt-12"
          role="alert"
        >
          {{ error }}
        </p>
        <p
          v-if="success"
          class="notice notice-success mt-12"
          role="status"
        >
          Gespeichert.
        </p>

        <div class="dlg-footer">
          <button
            class="btn"
            :disabled="loading"
            @click="emitClose"
          >
            Abbrechen
          </button>
          <button
            class="btn btn-primary"
            :disabled="loading"
            @click="save"
          >
            <span
              v-if="loading"
              class="spinner"
              aria-hidden="true"
            />
            Speichern
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useTicketsStore } from '@/stores/tickets';

const props = defineProps({
  open: { type: Boolean, default: false },
  ticket: { type: Object, default: null }
});
const emit = defineEmits(['close', 'saved']);

const store = useTicketsStore();

const status = ref('open');
const loading = ref(false);
const error = ref('');
const success = ref(false);

watch(() => props.open, (v) => {
  if (v && props.ticket) {
    status.value = props.ticket.status || 'open';
    error.value = '';
    success.value = false;
  }
});

function emitClose() {
  emit('close');
}

async function save() {
  if (!props.ticket?.id) return;
  error.value = '';
  success.value = false;
  loading.value = true;
  try {
    await store.setStatus(props.ticket.id, status.value);
    success.value = true;
    emit('saved');
  } catch (e) {
    error.value = e?.response?.data?.message || e?.message || 'Speichern fehlgeschlagen.';
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.dlg-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.35);
  display:flex; align-items:center; justify-content:center; z-index: 1000;
}
.dlg {
  width: min(520px, 94vw);
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,.18);
  padding: 16px;
}
.dlg-header {
  display:flex; align-items:center; justify-content:space-between;
  border-bottom: 1px solid var(--border); padding-bottom: 8px; margin-bottom: 12px;
}
.dlg-footer { display:flex; gap:8px; justify-content:flex-end; margin-top: 8px; }
.form { display:flex; flex-direction:column; gap:12px; }
.field input, .field select {
  height: 38px; padding: 8px; border: 1px solid var(--border); border-radius: 8px; background: var(--surface);
}
.icon-btn {
  display:inline-flex; align-items:center; justify-content:center; height:36px; width:36px;
  border-radius:8px; border:1px solid var(--border); background:var(--surface); color:var(--text); cursor:pointer;
}
.icon-btn:hover { background: color-mix(in srgb, var(--primary) 8%, transparent); }
</style>
